import { ApolloError, gql as GraphQL, useQuery, useMutation } from "@apollo/client";

export interface DataType {
    profile: IProfile;
}

const QueryGraphQL = GraphQL`
    query getServerPageQuery {
        getProfile {
            _id
            customer(plans: [0,1,2,3])
            settings {
                user {
                    username
                    discriminator
                    avatar
                    email
                    stripeId
                }
                premium {
                    status
                    planId
                }
            }
        }
    }
`;

const MutationGraphQL = GraphQL`
    mutation setProfileMutation($id: String!, $data: String!) {
        setProfile(id: $id, data: $data) {
            _id
        }
    }
`;

const Query = (): { loading: boolean; error: ApolloError | undefined; data: DataType | null; refetch: Function } => {
    const { loading, error, data, refetch } = useQuery(QueryGraphQL);

    if (error) console.log(error);

    if (loading || error) return { loading: true, error, data: null, refetch };

    return { loading: false, error, data: { profile: data.getProfile }, refetch };
};

const Mutation = () => useMutation(MutationGraphQL)[0];

const Hook = { Query, Mutation };

export default Hook;
